export default "__VITE_ASSET__BFJagzEa__"